import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CampaignSearchComponent } from '../components/campaign-search/campaign-search.component';

@Component({
    selector: 'app-campaigns-list',
    templateUrl: './campaigns-list.component.html',
    styleUrls: ['./campaigns-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CampaignSearchComponent]
})
export class CampaignsListComponent {

  constructor() { }

}
